export const freeShipping = {
  methods: {
    //used to supply the info needed for the shipping threshold bar in the side cart.
    distanceToFreeShipping() {
      //take current cart totally and reduce it by any items that don't apply to the shipping threshold (gift cards, donations, insurance, carbon offset)
      //might be a tag on the product that defines exclusions?
      // $100 shipping threshold.
      //let freeShippingNeed = 10000;
      // $99 shipping threshold
      let freeShippingNeed = 9900;
      // $50 shipping threshold.
      // let freeShippingNeed = 5000;
      //TODO: remove items from total that don't count towards shipping
      let cartValue = this.cart.total_price;
      this.cart.items.forEach((lineItem) => {
        if (this.excludedFromShippingThreshHold(lineItem)) {
          //remove final line price, as it includes quantity + any applied discounts
          cartValue -= lineItem.final_line_price;
        }
      });
      return freeShippingNeed - cartValue < 0
        ? 0
        : freeShippingNeed - cartValue;
    },
    excludedFromShippingThreshHold(lineItem) {
      let productType = lineItem.product_type.toLowerCase();
      //just do lower case to keep it consistant. covers us if they make a new product and do the case differently.
      let excludedTypes = [
        'gift card',
        'donation',
        'carbon offset',
        'insurance',
      ];
      if (excludedTypes.includes(productType)) {
        return true;
      }
      return false;
    },
  },
};
